import { render, staticRenderFns } from "./Holic.vue?vue&type=template&id=14197262&scoped=true"
import script from "./Holic.vue?vue&type=script&lang=js"
export * from "./Holic.vue?vue&type=script&lang=js"
import style0 from "./Holic.vue?vue&type=style&index=0&id=14197262&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14197262",
  null
  
)

export default component.exports